class CnR {
	api_version = "2024-04";
	keyname = "subscriptions-2024-02";
	constructor(opts = {}) {
		this.config = { ...this.defaults(), ...opts };
		this.inject_css();
	}
	defaults() {
		return {
			api_version: "2023-07",
			keyname: "subscriptions-2024-02",
		};
	}
	fetch(url, config) {
		if (this.config.fetch_function) {
			return default_fetch(url, config);
		} else {
			return fetch(url, config);
		}
	}
	/* shopify cart functions */
	async getCart(url = "/cart.js", extended = false, callback = () => {}) {
		let cart = {};
		return this.fetch(url).then((res) => (extended ? res.text() : res.json()));
	}
	async request(url) {
		return this.fetch(url).then((text) => response.text());
	}
	async updateCart(payload) {
		return this.fetch(`/cart/update.js`, {
			method: "POST",
			credentials: "same-origin",
			headers: {
				"Content-Type": "application/json",
				"X-Requested-With": "xmlhttprequest",
			},
			body: JSON.stringify(payload),
		}).then((response) => response.json());
	}
	async removeItemFromCart(key) {
		return this.changeCart({
			id: key,
			quantity: 0,
		});
	}
	async updateItemCount(key, quantity) {
		return this.changeCart({
			id: key,
			quantity: parseInt(quantity),
		});
	}
	async changeCart(payload) {
		return this.fetch(`/cart/change.js`, {
			method: "POST",
			credentials: "same-origin",
			headers: {
				"Content-Type": "application/json",
				"X-Requested-With": "xmlhttprequest",
			},
			body: JSON.stringify(payload),
		}).then((response) => response.json());
	}
	async addToCart(payload) {
		let config = {
			method: "POST",
			credentials: "include",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(payload),
		};
		return this.fetch("/cart/add.js", config).then((response) =>
			response.json()
		);
	}

	static setupDawnProductForm(form) {
		form.querySelector("button").addEventListener("click", (event) => {
			event.preventDefault();
			event.stopPropagation();
			new CnR().addToDawnCart(form).then((response) => {});
		});
	}
	async addToDawnCart(form) {
		let cart = document.querySelector("cart-drawer");
		const formData = new FormData();
		formData.append("product-id", form.dataset.productId);
		formData.append("id", form.querySelector('[name="id"]').value);
		formData.append("quantity", 1);
		try {
			formData.append(
				"selling_plan",
				form.querySelector('[name="selling_plan"]').value
			);
		} catch (e) {}

		formData.append(
			"sections",
			cart.getSectionsToRender().map((section) => section.id)
		);
		formData.append("sections_url", form.dataset.url);
		formData.append("form_type", "product");

		return this.fetch("/cart/add", {
			method: "POST",
			headers: {
				Accept: "application/javascript",
				"X-Requested-With": "XMLHttpRequest",
			},
			body: formData,
			form,
		})
			.then((response) => response.json())
			.then((json) => {
				if (json.status) {
					CnRModal.show(json.description);
				} else {
					cart.renderContents(json);
					cart.classList.remove("is-empty");
				}
				return json;
			});
	}

	/* graphql functions */
	async graphql(query, params) {
		return fetch(`/api/${this.api_version}/graphql.json`, {
			method: "POST",
			headers: {
				"content-type": "application/json",
				"X-Shopify-Storefront-Access-Token": this.config.graphql_token,
			},
			body: JSON.stringify({ query: query, variables: params }),
		}).then((response) => response.json());
	}
	graphql_sync(query, params) {
		let ajax = new XMLHttpRequest();
		ajax.headers = {
			"content-type": "application/json",
			"X-Shopify-Storefront-Access-Token": this.config.graphql_token,
		};
		ajax.open("POST", /api/`${this.api_version}/graphql.json`, false);
		ajax.setRequestHeader("Content-Type", "application/json");
		ajax.setRequestHeader(
			"X-Shopify-Storefront-Access-Token",
			storefront_token
		);
		ajax.send(JSON.stringify({ query: query, params: params }));
		return JSON.parse(ajax.responseText);
	}
	gid2id(gid) {
		return parseInt(gid.split("/").pop());
	}
	collapse_query(object) {
		if (object == null) {
			return object;
		}
		switch (object.constructor.name) {
			case "Array":
				return object.map((item) => this.collapse_query(item));
				break;
			case "Object":
				let ret = {};
				Object.keys(object).forEach((key) => {
					if (object[key] == null) {
						ret[key] = null;
						return;
					}
					if (object[key].reference) {
						ret[key] = this.collapse_query(object[key].reference);
						return;
					}
					if (object[key].references) {
						let all = [];
						object[key].references.nodes.forEach((ref) => {
							let crv = {};
							ref.fields.forEach((field) => {
								crv[field.key] = this.collapse_query(field.value);
							});
							all.push(crv);
						});
						object[key] = all;
					}
					if (
						object[key].nodes &&
						object[key].nodes.constructor.name == "Array"
					) {
						ret[key] = this.collapse_query(object[key].nodes);
					} else {
						ret[key] = this.collapse_query(object[key]);
					}
				});
				return ret;
				break;
			default:
				if (object) {
					return object;
				}

				break;
		}
	}
	css() {
		return "";
	}
	inject_css() {
		let css = this.css();
		if (css.length > 0) {
			let style = document.createElement("style");
			style.id = this.constructor.name.toLowerCase();
			style.textContent = this.css();
			document.querySelector("head").appendChild(style);
		}
	}
}
/* cnr-modal/cnr-modal.js  */
class CnRModal extends CnR {
	static show(content, cls = "standard") {
		let modal = document.querySelector(".cnr-modal");
		if (!modal) {
			modal = document.createElement("DIV");
			modal.classList.add("cnr-modal");
			document.querySelector("body").appendChild(modal);
		}
		modal.style.width = `${window.innerWidth}px`;
		modal.style.height = `${window.innerHeight}px`;
		modal.style.top = `${window.scrollY}px`;
		modal.innerHTML = `
        <div class="modal-content ${cls}">
            <span class="close">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" role="presentation"><path d="M5.86123 14.1073L5.21766 14.1073L3.67204 12.5617L3.67204 11.9181L6.68057 8.90959L3.6521 5.88112L3.6521 5.23755L5.2376 3.65205L5.88117 3.65204L8.90964 6.68052L11.9182 3.67199L12.5617 3.67199L14.1074 5.21761L14.1074 5.86118L11.0988 8.86971L14.1273 11.8982L14.1273 12.5417L12.5418 14.1273H11.8982L8.86976 11.0988L5.86123 14.1073Z" fill="#af3939"></path></svg>
            </span>
            <div class="modal-text text-left color-foreword-primary body1">
                ${content}
            </div>
        </div>
        `;
		modal.querySelector(".close").addEventListener("click", (event) => {
			modal.classList.remove("active");
			modal.innerHTML = "";
			document.querySelector("body").classList.remove("stop-scrolling");
		});
		modal.addEventListener("click", (event) => {
			if (event.target.classList.contains("cnr-modal")) {
				modal.classList.remove("active");
				modal.style.top = "0px";
				modal.innerHTML = "";
				document.querySelector("body").classList.remove("stop-scrolling");
			}
		});
		document.querySelector("body").classList.add("stop-scrolling");
		modal.classList.add("active");
	}
	static close() {
		let modal = document.querySelector(".cnr-modal");
		modal.classList.remove("active");
		modal.innerHTML = "";
		document.querySelector("body").classList.remove("stop-scrolling");
	}
}

class WaitFor {
	constructor(item, callback, timeout = 50, attempts = 50) {
		this.iterations = 0;
		this.timeout = timeout;
		this.attempts = attempts;
		this.id = window.setInterval(() => {
			this.iterations++;

			let element = document.querySelector(item);
			if (element) {
				window.clearInterval(this.id);
				callback(element);
			} else if (this.iterations >= this.attempts) {
				window.clearInterval(this.id);
			}
		}, this.timeout);
	}
}

/* cnr-pdp-subscription-widget/pdp-subscription-widget.js  */
class CnRSubscriptionsWidget extends CnR {
	defaults() {
		return {
			default_to_subscription: true,
			onetime_label: "One Time Purchase",
			subscription_label: "Autoship & save",
			delivery_label: "Every",
			injection_point: ".cnr-subscription-widget",
			form_selector: "[data-product-form]",
			krc: true,
			selling_group_index: 1,
		};
	}
	constructor(options) {
		super(options);
		this.selling_plans = {};
		this.optionIndex = 0;
		this.load_product(this.config.product).then((q) => {
			this.config.product = q.data.product;
			this.config.variants = q.data.product.variants.nodes.map((variant) =>
				this.addVariant(variant)
			);
			if (!this.config.variant_id) {
				this.config.selected_variant = this.config.variants[1];
			} else {
				this.config.selected_variant = this.config.variants.find(
					(variant) => variant.id == this.config.variant_id
				);
			}
			if (q.data && q.data.product) {
				if (q.data.product.sellingPlanGroups.nodes.length > 0) {
					this.selling_plans = this.parseSellingPlans(q);
					const defaultPlan = this.defaultSellingPlan(
						this.selling_plans.options
					);
					if (!this.config.selling_plan_id) {
						if (this.config.default_to_subscription) {
							this.config.selling_plan = defaultPlan;
							this.config.last_selling_plan = defaultPlan;
						} else {
							this.config.last_selling_plan = defaultPlan;
						}
					} else {
						this.config.selling_plan = this.selling_plans.options.find(
							(plan) => plan.id == this.config.selling_plan_id
						);
						this.config.last_selling_plan = this.config.selling_plan;
					}
				}
			}
			document.addEventListener("CartUpdated", (event) => {
				this.cart = event.detail;
				this.render();
			});
			document.addEventListener("VariantChanged", (event) => {
				this.config.selected_variant = this.config.variants.find(
					(variant) => variant.id == parseInt(event.detail)
				);
				this.render();
			});
			this.monitorForm();
			this.killReCharge();
			this.render();
		});
	}
	addVariant(variant) {
		return {
			id: this.gid2id(variant.id),
			price: parseFloat(variant.price.amount),
		};
	}
	parseSellingPlans(q) {
		return this.parseSellingPlansV2(q);
	}
	parseIntervalDays(label) {
		const match = String(label).match(/(\d+)/);
		return match ? parseInt(match[1], 10) : 0;
	}
	sortSellingPlanOptions(options) {
		return [...options].sort(
			(a, b) => this.parseIntervalDays(a.label) - this.parseIntervalDays(b.label)
		);
	}
	defaultSellingPlan(options) {
		if (!options?.length) {
			return undefined;
		}
		return options.find((plan) => plan.label === "30-day") || options[0];
	}
	parseSellingPlansV1(q) {
		const nodes = q.data.product.sellingPlanGroups.nodes;
		const group =
			nodes.find((g) => g.appName === "294517") || nodes[nodes.length - 1];
		const options = group.sellingPlans.nodes.map((selling_plan) => {
			return {
				id: this.gid2id(selling_plan.id),
				label: selling_plan.options[1].value,
				discount:
					selling_plan.priceAdjustments[0].adjustmentValue.percent / 100,
			};
		});
		return {
			group_id: group.name,
			options: this.sortSellingPlanOptions(options),
		};
	}
	parseSellingPlansV2(q) {
		let by_app = {};

		q.data.product.sellingPlanGroups.nodes.forEach((group) => {
			if (!by_app[group.appName]) {
				by_app[group.appName] = [];
			}

			by_app[group.appName].push({
				id: this.gid2id(group.sellingPlans.nodes[0].id),
				label: group.name,
				discount:
					group.sellingPlans.nodes[0].priceAdjustments[0].adjustmentValue
						.percent / 100,
			});
		});

		return {
			group_id: this.config.subscription_label,
			options: this.config.use_app
				? by_app[this.config.use_app]
				: Object.values(by_app).pop(),
		};
	}
	load_product(id) {
		return this.graphql(
			`
    query getProducts($id: ID!) @inContext(country: ${window.Shopify.country}) {
      product(id:$id) {
        id
        variants(first:100) {
          nodes {
            id
            price {
              amount
              currencyCode
            }${this.additionalVariantQuery()}
          }
        }
        ${this.additionalProductQuery()}
        sellingPlanGroups(first: 10) {             
          nodes {
            appName
            name
            sellingPlans(first:250) {
              nodes {  
                recurringDeliveries
                id
                options {
                  value
                }
                description
                priceAdjustments {
                  adjustmentValue {
                    ... on SellingPlanPercentagePriceAdjustment {
                      percent: adjustmentPercentage
                    }
                    ... on SellingPlanFixedPriceAdjustment {
                      amount: price {
                        amount
                        currencyCode
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }`,
			{ id: `gid://shopify/Product/${id}` }
		);
	}
	additionalVariantQuery() {
		return "";
	}
	additionalProductQuery() {
		return `
		handle
		`;
	}
	regular_price() {
		return this.config.selected_variant.price;
	}
	display_regular_price() {
		return `$${this.regular_price().toFixed(2)}`;
	}
	discounted_price() {
		let selling_plan = this.config.selling_plan;
		if (!selling_plan) {
			selling_plan = this.config.last_selling_plan;
		}
		return (
			this.config.selected_variant.price *
			(1 - (selling_plan ? selling_plan.discount : 0))
		);
	}
	current_price() {
		if (this.config.selling_plan) {
			window.currentPrice = this.discounted_price();
			return this.discounted_price();
		} else {
			window.currentPrice = this.regular_price();
			return this.regular_price();
		}
	}
	frequency_label() {
		return this.config.selling_plan ? this.config.selling_plan.label : "";
	}
	display_discounted_price() {
		return `$${this.discounted_price().toFixed(2)}`;
	}
	subscription_label() {
		return `${this.config.subscription_label.replace(
			"##discount##",
			this.config.last_selling_plan?.discount * 100
		)}%`;
	}
	onetime_label() {
		return this.config.onetime_label;
	}
	killReCharge() {
		this.rci = window.setInterval(() => {
			let recharge = document.querySelector(".recharge-subscription-widget");
			if (recharge) {
				recharge.parentElement.removeChild(recharge);

				window.clearInterval(this.rci);
			}
		}, 200);
	}
	monitorForm() {
		let id = document
			.querySelector(this.config.form_selector)
			.querySelector('[name="id"]');

		this.variant_observer = new MutationObserver((list, observer) => {
			let variant_id = parseInt(id.value);
			this.config.selected_variant = this.config.variants.find(
				(variant) => variant.id == variant_id
			);
			this.render();
		});
		this.variant_observer.observe(id, {
			attributes: true,
			subtree: false,
			childList: false,
		});
	}
	onetime_label_extra() {
		return ``;
	}
	subscriptions_label_extra() {
		return "";
	}
	onetime_block_extra() {
		return "";
	}
	subscriptions_block_extra() {
		return "";
	}
	container_extra() {
		return "";
	}
	delivery_string() {
		return "Delivers every";
	}
	format_label(label) {
		return label;
	}
	broadcastPlan(id) {
		document.dispatchEvent(
			new CustomEvent("cnr:subscriptions:planUpdated", {
				bubbles: true,
				detail: id,
			})
		);
	}

	render() {
		console.log("=== RENDER STARTED ===");
		console.log("productData:", this.productData);

		const recommendedOption = "30-day";
		let label = "Every";
		const isTeaProduct =
			this.isInCollection(408406159) ||
			this.hasAnyTag(["tea", "loose leaf tea"]);
		console.log("isTeaProduct:", isTeaProduct);
		if (isTeaProduct) {
			label = "Delivers Every";
		}
		let render_radio_buttons = (plans) => {
			let selected_plan =
				this.config.selling_plan || this.config.last_selling_plan;
			return `
        <div class="options-selector ${
					plans?.length > 1 ? "multiple-options" : ""
				}">
          <div class="plan-single-label">${
						this.config.delivery_label
					} ${this.format_label(selected_plan?.label)}</div>
          <div class="radio-options">
            ${plans
							?.map((plan) => {
								return `
                  <input type="radio" name="selling_plan_id" id="${
										plan.id
									}" value="${plan.id}" ${
									recommendedOption == plan.label ? "checked" : ""
								}>
                  <label for="${plan.id}">
                    ${
											plan.label === recommendedOption
												? `<span class="option-badge">Recommended</span>`
												: ""
										}
                    
                    <small>${label}</small> 
                    ${this.format_label(plan.label)}
                  </label>
                `;
							})
							.join("")}
          </div>
        </div>`;
		};

		let root = document.querySelector(this.config.injection_point);

		// Check if product is in Loose Leaf Tea collection OR has tea tags

		if (isTeaProduct) {
			root.innerHTML = `
      <div id="rc_container">
        <div class="rc-section ${
					!this.config.selling_plan ? "rc-section--active" : ""
				}"">
          <div class="rc_block rc_block__type rc_block__type__onetime ${
						!this.config.selling_plan ? "rc_block__type--active" : ""
					}" >
          <div class="description">
            <input type="radio" id="rc_purchase_type_onetime" name="purchase_type" value="onetime" data-selling-plan="" class="rc_radio rc_radio__onetime" ${
							!this.config.selling_plan ? "checked" : ""
						} data-purchase-type="onetime">
            <span class="checkmark"></span>
            <label for="rc_purchase_type_onetime" class="rc_label rc_label__onetime body2">
              <span class="rc_description">${this.onetime_label()}</span>
              <p>
                <span id="rc_price_onetime" class="rc_price rc_price__onetime" aria-label="original price">${this.display_regular_price()}</span>
                <span id="rc_extra">${this.onetime_label_extra()}</span>
              </p>
            </label>

            <div class="icon-text__items">
              <div class="icon-text__item">
                <img src="https://cdn.shopify.com/s/files/1/1583/7395/files/no-dollars_svgrepo.com.svg?v=1746541464" width="18" height="18" loading="lazy">
                <span class="icon-text__text">No commitment</span>
              </div>

              <div class="icon-text__item">
                <img src="https://cdn.shopify.com/s/files/1/1583/7395/files/sleep_svgrepo.com_1.svg?v=1746541462" width="18" height="18" loading="lazy">
                <span class="icon-text__text">For First-Timers</span>
              </div>

              <div class="icon-text__item">
                <img src="https://cdn.shopify.com/s/files/1/1583/7395/files/purchase_svgrepo.com.svg?v=1746541459" width="18" height="18" loading="lazy">
                <span class="icon-text__text">Stress-Free</span>
              </div>
            </div>
          </div>
        </div>
        </div>
        <div class="rc-section ${
					this.config.selling_plan ? "rc-section--active" : ""
				}">
          <div id="rc_radio_options" role="radiogroup" aria-labelledby="Purchase options">
            
          <div class="rc_block rc_block__type rc_block__type__autodeliver ${
						this.config.selling_plan ? "rc_block__type--active" : ""
					} ${this.selling_plans.options?.length > 0 ? "" : "d-none"}" >
            <div class="description">
              <input type="radio" name="purchase_type" id="rc_purchase_type_autodeliver" value="autodeliver"  class="rc_radio rc_radio__autodeliver" ${
								this.config.selling_plan ? "checked" : ""
							} data-purchase-type="autodeliver">
              <span class="checkmark"></span>
              <label for="rc_purchase_type_autodeliver" class="rc_label rc_label__autodeliver body2">
                  <span class="rc_description">${this.subscription_label()}</span>
                  <p>
                    <span id="rc_price_autodeliver" class="rc_price rc_price__autodeliver" aria-label="recurring price">${this.display_discounted_price()}</span>
                    <span id="rc_extra">${this.subscriptions_label_extra()}</span>
                  </p>
                </label>
                <div class="block-extra-content">${this.subscriptions_block_extra()}</div>
              </div>
              <div id="rc_autodeliver_options" class="rc_block__type__options">
                ${render_radio_buttons(this.selling_plans.options)}
              </div>

              <p class="supply-text">One bag is approximately <span>30 days</span> supply when enjoyed daily</p>
            </div>
            <div class="container-extra">${this.container_extra()}</div>
          </div>
          <div class="subscription-frequency-label">${this.frequency_label()}</div>
            ${this.extraHTML()}
          </div>
        
        </div>
        

        

    `;
		} else {
			root.innerHTML = `
        <div class="rc-section">
          <div id="rc_container">
            <div id="rc_radio_options" role="radiogroup" aria-labelledby="Purchase options">
              
            <div class="rc_block rc_block__type rc_block__type__autodeliver ${
							this.config.selling_plan ? "rc_block__type--active" : ""
						} ${this.selling_plans.options?.length > 0 ? "" : "d-none"}" >
              <div class="description">
                <input type="radio" name="purchase_type" id="rc_purchase_type_autodeliver" value="autodeliver"  class="rc_radio rc_radio__autodeliver" ${
									this.config.selling_plan ? "checked" : ""
								} data-purchase-type="autodeliver">
                <label for="rc_purchase_type_autodeliver" class="rc_label rc_label__autodeliver body2">
                    <span class="rc_description">${this.subscription_label()}</span>
                    <p>
                      <span id="rc_price_autodeliver" class="rc_price rc_price__autodeliver" aria-label="recurring price">${this.display_discounted_price()}</span>
                      <span id="rc_extra">${this.subscriptions_label_extra()}</span>
                    </p>
                  </label>
                  <div class="block-extra-content">${this.subscriptions_block_extra()}</div>
                </div>
                <div id="rc_autodeliver_options" class="rc_block__type__options">
                  ${render_radio_buttons(this.selling_plans.options)}
                </div>
              </div>
              <div class="container-extra">${this.container_extra()}</div>
            </div>

            <div class="rc_block rc_block__type rc_block__type__onetime ${
							!this.config.selling_plan ? "rc_block__type--active" : ""
						}" >
              <div class="description">
                <input type="radio" id="rc_purchase_type_onetime" name="purchase_type" value="onetime" data-selling-plan="" class="rc_radio rc_radio__onetime" ${
									!this.config.selling_plan ? "checked" : ""
								} data-purchase-type="onetime">
                <label for="rc_purchase_type_onetime" class="rc_label rc_label__onetime body2">
                  <span class="rc_description">${this.onetime_label()}</span>
                  <p>
                    <span id="rc_price_onetime" class="rc_price rc_price__onetime" aria-label="original price">${this.display_regular_price()}</span>
                    <span id="rc_extra">${this.onetime_label_extra()}</span>
                  </p>
                </label>

                <div class="icon-text__items">
                  <div class="icon-text__item">
                    <img src="https://cdn.shopify.com/s/files/1/1583/7395/files/no-dollars_svgrepo.com.svg?v=1746541464" width="18" height="18" loading="lazy">
                    <span class="icon-text__text">No commitment</span>
                  </div>

                  <div class="icon-text__item">
                    <img src="https://cdn.shopify.com/s/files/1/1583/7395/files/sleep_svgrepo.com_1.svg?v=1746541462" width="18" height="18" loading="lazy">
                    <span class="icon-text__text">For First-Timers</span>
                  </div>

                  <div class="icon-text__item">
                    <img src="https://cdn.shopify.com/s/files/1/1583/7395/files/purchase_svgrepo.com.svg?v=1746541459" width="18" height="18" loading="lazy">
                    <span class="icon-text__text">Stress-Free</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="subscription-frequency-label">${this.frequency_label()}</div>
              ${this.extraHTML()}
            </div>
        </div>
    `;
		}

		let plan_input = document
			.querySelector(this.config.form_selector)
			.querySelector('[name="selling_plan"]');
		if (!plan_input) {
			window.clearInterval(this.id);
			plan_input = document.createElement("input");
			plan_input.type = "hidden";
			plan_input.name = "selling_plan";
			document.querySelector(this.config.form_selector).appendChild(plan_input);
		}
		if (plan_input && this.config.selling_plan) {
			plan_input.value = this.config.selling_plan.id;
			this.broadcastPlan(plan_input.value);
		}

		// Event listener for purchase type radio buttons
		root.querySelectorAll('input[name="purchase_type"]').forEach((radio) => {
			radio.addEventListener("change", (event) => {
				switch (radio.dataset.purchaseType) {
					case "onetime":
						this.config.last_selling_plan = this.config.selling_plan;
						this.config.selling_plan = null;

						plan_input.value = "";
						break;
					case "autodeliver":
						if (this.config.last_selling_plan) {
							this.config.selling_plan = this.config.last_selling_plan;
						} else {
							this.config.selling_plan = this.defaultSellingPlan(
								this.selling_plans.options
							);
						}
						plan_input.value = this.config.selling_plan.id;
						break;
				}
				this.broadcastPlan(plan_input.value);
				this.render();

				// Update the ATC button price when purchase type changes
				this.enhanceATC();

				// Notify main quantity system of subscription change
				document.dispatchEvent(
					new CustomEvent("cnr:subscriptions:planUpdated", {
						bubbles: true,
						detail: {
							selling_plan: this.config.selling_plan,
							purchase_type: radio.dataset.purchaseType,
						},
					})
				);
			});
		});

		// Event listener for selling plan radio buttons
		root.querySelectorAll('input[name="selling_plan_id"]').forEach((radio) => {
			radio.addEventListener("change", (event) => {
				const value = event.target.value;
				this.config.last_selling_plan = this.config.selling_plan;
				this.config.selling_plan = this.selling_plans.options.find(
					(plan) => plan.id == parseInt(value)
				);
				this.broadcastPlan(value);

				plan_input.value = value;

				// Update the ATC button price when subscription plan changes
				this.enhanceATC();

				// Notify main quantity system of subscription change
				document.dispatchEvent(
					new CustomEvent("cnr:subscriptions:planUpdated", {
						bubbles: true,
						detail: {
							selling_plan: this.config.selling_plan,
							purchase_type: "subscription",
						},
					})
				);
			});
		});
	}

	extraHTML() {
		return "";
	}
}
/* llt.js  */
class LooseLeafSubscriptionWidget extends CnRSubscriptionsWidget {
	constructor(options) {
		super(options);
		this.productData = null; // Will store collections and tags

		// Load product metadata (collections, tags) from JSON template
		this.loadProductMetadata();
		document.addEventListener("productInfo:loaded", (event) => {
			this.enhanceATC();
			document.dispatchEvent(
				new CustomEvent("sticky:variantUpdated", {
					bubbles: true,
					detail: this.config.selected_variant.id,
				})
			);
		});
		document.addEventListener("cnr:subscriptions:updateVariant", (event) => {
			this.config.selected_variant = this.config.variants.find(
				(variant) => variant.id == parseInt(event.detail)
			);
			this.render();
		});
	}

	/**
	 * Load product metadata (collections and tags) from JSON template
	 * Data is fetched from /products/{handle}?view=wsg-json
	 *
	 * Usage examples:
	 * - Listen for the loaded event:
	 *   document.addEventListener('cnr:productMetadata:loaded', (e) => {
	 *     console.log('Collections:', e.detail.collectionIds);
	 *     console.log('Tags:', e.detail.tags);
	 *   });
	 *
	 * - Check collections and tags:
	 *   if (subscriptions.isInCollection(123456789)) { ... }
	 *   if (subscriptions.hasTag('tea')) { ... }
	 *   if (subscriptions.hasAnyTag(['tea', 'loose leaf tea'])) { ... }
	 */
	async loadProductMetadata() {
		// Wait for product data to be loaded first
		if (!this.config.product || !this.config.product.handle) {
			// Retry after a short delay
			setTimeout(() => this.loadProductMetadata(), 100);
			return;
		}

		try {
			const handle = this.config.product.handle;
			const response = await fetch(`/products/${handle}?view=wsg-json`);
			const data = await response.json();
			this.productData = data;

			console.log("PRODUCT TAGS", this.productData.productTags);
			console.log("COLLECTION IDS", this.productData.collectionIds);

			// Re-render the widget now that we have the metadata
			this.render();

			// Dispatch event that metadata is loaded
			document.dispatchEvent(
				new CustomEvent("cnr:productMetadata:loaded", {
					bubbles: true,
					detail: {
						collectionIds: data.collectionIds,
						tags: data.productTags,
					},
				})
			);
		} catch (error) {
			console.error("Failed to load product metadata:", error);
		}
	}

	// Check if product is in a specific collection by ID
	isInCollection(collectionId) {
		if (!this.productData || !this.productData.collectionIds) {
			return false;
		}
		return this.productData.collectionIds.includes(parseInt(collectionId));
	}

	// Check if product has a specific tag (case-insensitive)
	hasTag(tagName) {
		if (!this.productData || !this.productData.productTags) {
			return false;
		}
		return this.productData.productTags.some(
			(tag) => tag.toLowerCase() === tagName.toLowerCase()
		);
	}

	// Check if product has any of the specified tags (case-insensitive)
	hasAnyTag(tagNames) {
		if (!Array.isArray(tagNames)) {
			tagNames = [tagNames];
		}

		return tagNames.some((tagName) => this.hasTag(tagName));
	}

	// Get all product tags
	getTags() {
		return this.productData?.productTags || [];
	}

	// Get all collection IDs
	getCollectionIds() {
		return this.productData?.collectionIds || [];
	}
	additionalVariantQuery() {
		return `
        cupsPer: metafield(key:"cups_per",namespace:"custom") {
          value
        }
      `;
	}
	onetime_block_extra() {
		return `<div class="one-time-info"><img src="https://cdn.shopify.com/s/files/1/1583/7395/files/icon-lightning.webp?v=1718645347" width=18" width="18" height="18" loading="lazy">Subscribing saves you <span class="discount">${
			this.config.last_selling_plan?.discount * 100
		}%</span> and helps you stay dedicated on your health journey. Commit to your wellness by switching to a subscription.</div>`;
	}
	subscription_block_extra() {
		return `<div class="subs-info">   
            <div class="modal-container">
              <p class="info_item">Skip, swap, or cancel anytime</p><p class="modal"> Learn More</p>
              <div class="modal__how_it_works">     
                <strong>How subscriptions work</strong><br>Products are automatically delivered on your schedule. No obligation, modify or cancel your subscription anytime.
              </div> 
            </div>
            <p class="info_item">Notifications sent 5 days before each delivery</p>
            <p class="info_item">Free 5 oz. Tea Tin with Subscription</p>
          </div>`;
	}

	addVariant(variant) {
		return {
			cupsPer: variant.cupsPer ? parseInt(variant.cupsPer.value) : 1,
			...super.addVariant(variant),
		};
	}
	monitorForm() {
		super.monitorForm();

		let form = document.querySelector(this.config.form_selector);
		if (form) {
			let quantity = form.querySelector('[name="quantity"]');
			if (quantity) {
				quantity.addEventListener("change", (event) =>
					document.dispatchEvent(
						new CustomEvent("cnr:subscriptions:quantityChanged", {
							bubbles: true,
							detail: quantity.value,
						})
					)
				);
			}
		}
	}
	container_extra() {
		return this.config.badge_text.replace(
			"##discount##",
			`${this.config.last_selling_plan?.discount * 100}%`
		);
	}
	format_label(label) {
		// if (!label) {
		// 	return;
		// }
		return super.format_label(label).replace("(", "").replace(")", "");
	}
	parseSellingPlans(q) {
		return this.parseSellingPlansV1(q);
	}
	discounted_price() {
		let selling_plan = this.config.selling_plan;
		if (!selling_plan) {
			selling_plan = this.config.last_selling_plan;
		}
		let provisional_price =
			this.config.selected_variant.price *
			(1 - (selling_plan ? selling_plan.discount : 0));
		return provisional_price;
	}
	extraHTML() {
		return `
        `;
	}
	onetime_label_extra() {
		return `$${(
			this.regular_price() / this.config.selected_variant.cupsPer
		).toFixed(2)}/cup`;
	}
	subscriptions_label_extra() {
		return `$${(
			this.discounted_price() / this.config.selected_variant.cupsPer
		).toFixed(2)}/cup`;
	}
	enhanceATC() {
		const currencyMapping = {
			BAM: "KM",
			USD: "$",
			EUR: "€",
			// Add other mappings as necessary
		};

		document.querySelectorAll(".product-form__submit").forEach((atc) => {
			let price = this.current_price().toFixed(2).split(".");
			const quantity =
				parseInt(document.getElementById("Quantity-buy_buttons").value) || 1;
			const currency = this.config.product.variants.nodes[0].price.currencyCode;
			const formattedPrice = currencyMapping[currency] || currency;
			if (atc) {
				// If subscription is active, show subscription price
				if (this.config.selling_plan) {
					const subscriptionPrice = this.discounted_price();
					const totalSubscriptionPrice = subscriptionPrice * quantity;
					const subscriptionPriceFormatted = totalSubscriptionPrice.toFixed(2).split(".");

					atc.innerHTML = `Add to Cart <span class="divider">&nbsp;-&nbsp;</span> <price-money><bdi><span class="price__prefix">${formattedPrice}&nbsp;</span>${parseInt(subscriptionPriceFormatted[0])}<sup class="price__suffix">.${subscriptionPriceFormatted[1]}</sup></bdi></price-money>`;
				} else {
					atc.innerHTML = `Add to Cart <span class="divider">&nbsp;-&nbsp;</span> <price-money><bdi><span class="price__prefix">${formattedPrice}&nbsp;</span>${
						parseInt(price[0]) * quantity
					}<sup class="price__suffix">.${price[1]}</sup></bdi></price-money>`;
				}
			}
		});
	}
	render() {
		console.log("=== LooseLeafSubscriptionWidget render() called ===");
		super.render();
		this.enhanceATC();
	}
}

/* cnr-quantity-field/cnr-quantity.js  */
class CnrQuantity {
	defaults() {
		return {
			min: 1,
			max: 999999,
			step: 1,
			value: 1,
			dataset: {},
		};
	}
	constructor(options = {}) {
		this.uuid = crypto.randomUUID();
		this.config = { ...this.defaults(), ...options };
	}
	dataset() {
		return Object.keys(this.config.dataset)
			.map((k) => `data-${k}="${this.config.dataset[k]}"`)
			.join(" ");
	}
	setdata(data) {
		this.config.dataset = {};
	}
	render() {
		return `
        <div class="cnr-quantity ${
					this.config.value > 0 ? "active" : ""
				}" data-uuid="${this.uuid}">
            <div class="wrapper">
                <span class="minus" data-uuid="${this.uuid}">-</span>
                <input type="number" name="quantity" class="quantity-input" min=${
									this.config.min
								}" max="${this.config.max}" step="${this.config.step}" value="${
			this.config.value
		}" data-uuid="${this.uuid}" ${this.dataset()}/>
                <span class="plus" data-uuid="${this.uuid}">+</span>
            </div>
            <span class="extra">${this.extra()}</span>
        </div>
        `;
	}
	static setupEvents() {
		document.querySelectorAll(".cnr-quantity").forEach((quantity) => {
			let current = quantity.querySelector(".quantity-input");
			quantity.querySelector(".plus").addEventListener("click", (event) => {
				if (current.disabled) {
					return;
				}
				if (parseInt(current.value) + 1 <= parseInt(current.max)) {
					current.value = parseInt(current.value) + 1;

					quantity.classList.add("active");
					this.active = true;
					document.dispatchEvent(
						new CustomEvent("cnr:quantity:changed", {
							bubbles: true,
							detail: {
								dataset: Object.assign({}, current.dataset),
								value: current.value,
								field: current,
							},
						})
					);
				}
			});
			quantity.querySelector(".minus").addEventListener("click", (event) => {
				if (current.disabled) {
					return;
				}
				if (parseInt(current.value) - 1 >= parseInt(current.min)) {
					current.value = parseInt(current.value) - 1;
					if (current.value <= parseInt(current.min)) {
						quantity.classList.remove("active");
					}
					document.dispatchEvent(
						new CustomEvent("cnr:quantity:changed", {
							bubbles: true,
							detail: {
								dataset: Object.assign({}, current.dataset),
								value: current.value,
								field: current,
							},
						})
					);
				}
			});
		});
	}
	extra() {
		return "";
	}
}
/* loose-leaf.js  */
class LooseLeafQuickAddQuantity extends CnrQuantity {
	extra() {
		return `<button class="remove-this" title="remove"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" class="icon icon-remove">
  <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
  <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
</svg></button>`;
	}

	static setupEvents() {
		CnrQuantity.setupEvents();
		document.querySelectorAll(`.cnr-quantity`).forEach((quant) => {
			let remover = quant.querySelector(".remove-this");
			if (remover) {
				remover.addEventListener("click", (event) => {
					document.dispatchEvent(
						new CustomEvent("cnr:quantity:changed", {
							bubbles: true,
							detail: {
								dataset: Object.assign(
									{},
									quant.querySelector("input").dataset
								),
								value: 0,
							},
						})
					);
				});
			}
		});
	}
}

/* cnr-quick-add/cnr-quick-add.js  */
class CnrQuickAdd extends CnR {
	constructor(options) {
		super(options);
		this.getCart().then((cart) => {
			this.cart = cart;

			this.load(this.config.product).then((q) => {
				this.processLoad(q.data);
			});
		});
	}
	refresh() {
		this.getCart().then((cart) => {
			this.cart = cart;
			let cart_variants = this.cart.items.map((item) => item.variant_id);
			let our_variants = this.variants.map((variant) => variant.id);
			this.variants
				.filter((variant) => !cart_variants.includes(variant.id))
				.forEach((variant) => {
					variant.quantity = 0;
					variant.cartLineId = null;
				});
			this.cart.items.forEach((item) => {
				let my_variant = this.variants.find((variant) => variant.id == item.id);
				if (my_variant) {
					my_variant.cartLineId = item.key;
					my_variant.quantity = item.quantity;
				}
			});
			this.updateCartCount(this.cart);
			this.render();
		});
	}
	processLoad(data) {
		this.product = data.product;
		this.variants = this.product.variants.nodes.map((variant) => {
			let variantId = this.gid2id(variant.id);
			let item_in_cart = this.cart.items.find((item) => item.id == variantId);
			let details = {
				id: variantId,
				title: variant.title,
				image: variant.image ? variant.image.url : null,
				price: parseFloat(variant.price.amount),
				available: variant.availableForSale,
				availableItems: variant.quantityAvailable,
				cartLineId: item_in_cart ? item_in_cart.key : null,
				quantity: item_in_cart ? item_in_cart.quantity : 0,
			};
			return { ...details, ...this.additionalVariantDetails(variant) };
		});
		this.render();
	}
	updateCartCount() {}
	load(id, after = null) {
		return this.graphql(
			`
          query getProduct($id:ID!) {
              product(id:$id) {
                  id
                  title
                  handle
                  options {
                      values
                  }
                  featuredImage {
                      id
                      url
                      altText
                  }
                  variants(first:100) {
                      nodes {
                          availableForSale
                          quantityAvailable
                          price {
                              amount
                          }
                          id
                          title
                          image {
                              url
                          }
                          ${this.additionalvariantQuery()}
                      }
                  }
                  media(first:100) {
                      nodes {
                          mediaContentType
                          alt
                          id
                          ... on MediaImage {
                              image {
                                  src: url
                                  width
                                  height
                              }
                          }
                          ... on Video {
                              sources {
                                  src: url
                                  mimeType
                                  format
                                  height
                                  width
                              }
                          }
                      }
                      pageInfo {
                          hasNextPage
                          endCursor
                      }
                  }
              }
              ${this.additionalProductQuery()}
          }`,
			{ id: `gid://shopify/Product/${id}` }
		);
	}
	additionalProductQuery() {
		return "";
	}
	additionalvariantQuery() {
		return "";
	}
	additionalVariantDetails(variant) {
		return {};
	}
	render() {
		let html = `
      <div class="cnr-quick-add-content ${
				this.totalItems() > 0 ? "active" : ""
			}">
        ${this.innerHTML()}
      </div>
      `;
		CnRModal.show(html);
		this.root = document.querySelector(".cnr-quick-add-content");
	}
	setupEvents() {}
	variantTitle(variant) {
		return variant.title;
	}
	extra() {
		return "";
	}
	activeVariants() {
		return this.variants.filter(
			(variant) => variant.cartLineId && variant.quantity > 0
		);
	}
	updateCartCount(cart = null) {}
	removeAll() {
		let payload = {};
		this.pause();

		this.activeVariants().forEach(
			(variant) => (payload[variant.id.toString()] = 0)
		);
		this.updateCart({ updates: payload }).then((response) => {
			this.updateCartCount();
			this.variants.forEach((variant) => {
				variant.quantity = 0;
				variant.cartLineId = null;
			});
			this.render();
		});
	}
	removeAllCB(items) {
		this.pause();
		if (items.length < 1) {
			this.variants.forEach((variant) => {
				variant.quantity = 0;
				variant.cartLineId = null;
			});
			this.render();
		} else {
			let next = items.pop();
			this.changeCart({
				id: next.id.toString(),
				quantity: 0,
			}).then((response) => {
				let my_variant = this.variants.find(
					(variant) => variant.id == parseInt(next.id)
				);
				if (my_variant) {
					my_variant.quantity = 0;
					my_variant.cartLineId = null;
					this.render();
				}
				this.removeAllCB(items);
			});
		}
	}
	pause() {
		this.root
			.querySelectorAll("input[type='number']")
			.forEach((input) => (input.disabled = true));
	}
	innerHTML() {
		return ``;
	}
	totalItems() {
		return this.activeVariants().reduce((a, b) => a + b.quantity, 0);
	}
	totalPrice() {
		return this.activeVariants().reduce((a, b) => a + b.quantity * b.price, 0);
	}

	updateVariant(event) {
		let data = event.detail.dataset;

		let variant = this.variants.find(
			(item) => item.id == parseInt(data.variantId)
		);
		if (variant) {
			if (event.detail.value < 1) {
				if (variant.cartLineId) {
					this.pause();

					this.removeItemFromCart(variant.id.toString()).then((response) => {
						this.updateCartCount();
						variant.quantity = 0;
						variant.cartLineId = null;
						this.render();
					});
				} else {
					variant.quantity = 0;
					variant.cartLineId = null;
					this.render();
				}
			} else {
				if (variant.cartLineId) {
					this.pause();
					this.updateItemCount(variant.id.toString(), event.detail.value).then(
						(response) => {
							this.updateCartCount();
							variant.quantity = parseInt(event.detail.value);
							this.render();
						}
					);
				} else {
					this.pause();

					this.addToCart({ id: data.variantId, quantity: 1 }).then(
						(response) => {
							this.updateCartCount();
							variant.cartLineId = response.key;
							variant.quantity = 1;
							this.render();
						}
					);
				}
			}
		}
	}
}
/* loose-leaf.js  */
class LooseLeafQuickAdd extends CnrQuickAdd {
	constructor(options) {
		super(options);
		document.addEventListener("cnr:quantity:changed", (event) => {
			this.updateVariant(event);
		});
		document.addEventListener("cnr:quantity:remove", (event) => {
			this.updateVariant(event);
		});
	}
	render() {
		super.render();
		LooseLeafQuickAddQuantity.setupEvents();

		this.root
			.querySelector(".remove-all")
			.addEventListener("click", (event) => {
				this.removeAll();
			});
		// this.root.querySelector(".view-cart").addEventListener("click", (event) => {
		// 	window.Rebuy.Cart.fetchShopifyCart((callback) =>
		// 		window.Rebuy.SmartCart.show()
		// 	);
		// 	CnRModal.close();
		// });
		this.root.querySelector(".view-cart").addEventListener("click", (event) => {
			window.Rebuy.Cart.fetchShopifyCart((cartData) => {
				window.Rebuy.SmartCart.show();
				CnRModal.close();
				document.dispatchEvent(
					new CustomEvent("rebuy:cart.viewed", {
						detail: { cart: { cart: cartData } },
					})
				);
			});
		});
	}
	updateCartCount(cart = null) {
		let cartCount = document.querySelector(
			".cart-count-bubble span[aria-hidden]"
		);
		if (cart) {
			cartCount.textContent = cart.item_count;
		} else {
			this.getCart().then((cart) => {
				this.cart = cart;
				cartCount.textContent = cart.item_count;
			});
		}
	}
	innerHTML() {
		let prices = this.variants
			.filter((variant) => variant.available)
			.map((variant) => variant.price);
		return `
<div class="quick-order">

<div class="quick-order-header-image">
	<div class="quick-product-image">
		 <img src="${this.product.featuredImage.url}&width=240" alt="${
			this.product.featuredImage.altText
		}"/>
	</div>
	<div class="quick-product-details large-up-hide">
			<h3>${this.product.title}</h3>
		<div class="product-price-range">
                <span class="min">$${Math.min(...prices).toFixed(2)}</span>
                -
                <span class="max">$${Math.max(...prices).toFixed(2)}</span>
        </div>
	</div>
</div>



<div class="quick-order-content">

<div class="quick-order-header quick-order-header-desktop small-hide medium-hide">
	<div class="quick-product-details">
	
			<h2>${this.product.title}</h2>
	
		<div class="product-price-range">
                <span class="min">$${Math.min(...prices).toFixed(2)}</span>
                -
                <span class="max">$${Math.max(...prices).toFixed(2)}</span>
        </div>
	</div>
</div>

<div class="quick-order-items">
	<table class="variant-list">
<thead>
             <tr>
               <th class="caption-with-letter-spacing" scope="col">Variant</th>
               <th class="large-up-hide right caption-with-letter-spacing variant-total-header" scope="col">Variant Total</th>
               <th
                 class="quick-order-list__table-heading--wide small-hide medium-hide caption-with-letter-spacing" scope="col">Quantity</th>
               <th
                 class="quick-order-list__table-heading--wide small-hide medium-hide caption-with-letter-spacing"
                 scope="col">Price</th>
               <th class="small-hide medium-hide right caption-with-letter-spacing" scope="col">Variant Total
       </th>
             </tr>
           </thead>
	  <tbody>
		${this.variants.map((variant) => this.renderVariantLine(variant)).join("")}
		</tbody>
	</table>
</div>

	<div class="quick-order-actions">
		<div class="total-items">
		<span>${this.totalItems()}</span>
		<span>total items</span>
		</div>
		<div class="subtotal">$${this.totalPrice().toFixed(2)}</div>
		<div class="all-buttons">
		<div class="total-button">
			<button class="view-cart button button--full-width">View Cart</button>
		</div>
		<div class="remove-all">
			<button class="remove-all-button">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" class="icon icon-remove">
                  <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
                  <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
                </svg>
            </button>
			<span>remove all</span>
		</div>
				</div>
	</div>

</div>

</div>
     
    `;
	}
	renderVariantLine(variant) {
		return `
	  
	  <tr class="variant-item">
	  	<td class="variant-item-image">
	  		<div class="variant-image-wrap">
		        <div class="variant-item-image-container">
		            <img class="variant-image" src="${
									variant.image
								}&crop=center&width=86">
		         </div>

		 	 	<div class="small-hide medium-hide">
		      		<span class="variant-item-name h4 break">${this.variantTitle(
								variant
							)}</span>
		    	</div>
	  		</div>
	  	</td>
	 
	  <td class="variant-title large-up-hide">
	  	<span class="variant-item-name"> ${this.variantTitle(variant)}</span>
	       <div class="price-per-item large-up-hide">
	        <span class="price-per-item--current price">
	        $${variant.price.toFixed(2)}/per
	        </span>
	      </div>
	  </td>
	 
         <td class="variant-totals right large-up-hide">
           <span class="price">$${variant.price * variant.quantity}</span>
         </td>
	
   
       <td class="quantity field">
         ${
						variant.available
							? new LooseLeafQuickAddQuantity({
									min: 0,
									max: variant.availableItems,
									value: variant.quantity,
									dataset: {
										"variant-id": variant.id,
										"line-id": variant.cartLineId,
									},
							  }).render()
							: "Sold Out"
					}
       </td>

  <td class="variant-item__price small-hide medium-hide">
	        <span class="price-per-item--current price">
	        $${variant.price.toFixed(2)}/per
	        </span>
</div>

         <td class="variant-totals right small-hide medium-hide">
          $${variant.price * variant.quantity}
         </td>
		 

	  </tr>
     `;

		/* 
      `<div class="variant">
          <div class="title field">
          <span class="image">
            <img src="${variant.image}&crop=center&width=24">
          </span>
            <span class="title-text">
              ${this.variantTitle(variant)}
          </span>
          </div>
          <div class="quantity field"></div>
          <div class="price_per field">$${variant.price.toFixed(2)}</div>
          <div class="price_total field">$${(variant.price*variant.quantity)}</div>
      </div>
      `
    */
	}
}
